import { createAsyncThunk } from '@reduxjs/toolkit'
import { ResolveUrl } from 'features/firebase-app'
import { getBearerToken } from '../../application/application-slice'

//Add types for inputs later.
export const CreateItemPlayer_byPlayerAsync = createAsyncThunk<any, any, any>(
  'composer/auto/playerController/player/CreateItem/Player',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('auto/playerController/player/CreateItem/Player'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: params !== undefined ? JSON.stringify(params) : null,
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)

//Add types for inputs later.
export const UpdateItemPlayer_byPlayerAsync = createAsyncThunk<any, any, any>(
  'composer/auto/playerController/player/UpdateItem/Player',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('auto/playerController/player/UpdateItem/Player'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: params !== undefined ? JSON.stringify(params) : null,
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)

//Add types for inputs later.
export const DeleteItemPlayer_byPlayerAsync = createAsyncThunk<any, any, any>(
  'composer/auto/playerController/player/DeleteItem/Player',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('auto/playerController/player/DeleteItem/Player'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: params !== undefined ? JSON.stringify(params) : null,
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)

//Add types for inputs later.
export const GetItemPlayer_byPlayerAsync = createAsyncThunk<any, any, any>(
  'composer/auto/playerController/player/GetItem/Player',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('auto/playerController/player/GetItem/Player'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: params !== undefined ? JSON.stringify(params) : null,
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)

//Add types for inputs later.
export const GetListPlayer_byPlayerAsync = createAsyncThunk<any, any, any>(
  'composer/auto/playerController/player/GetList/Player',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('auto/playerController/player/GetList/Player'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: params !== undefined ? JSON.stringify(params) : null,
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
